import {useState, useEffect} from 'react'
import {flowRight} from 'lodash-es'

// Component
import Details from './details.component'

// HOC
import {withLayout, withHooks} from '~/hocs'

// Constant
import {APP_URL} from '~/constants/app.constant'
import {DETAILS} from '~/constants/pages.constant'

// Util
import {
  enhancedGet, combineAddress, getYoutubeVideoId, getProductCardSrcSetAndSizes,
} from '~/utils'

const useHooks = (props) => {
  const {
    path,
    data,
  } = props

  const {
    acf,
    ...rest
  } = data.product

  const product = {
    ...acf,
    ...rest,
    gallery: enhancedGet(data, 'product.gallery', []),
    categories: enhancedGet(data, 'product.acf.categories', []),
    directions: enhancedGet(data, 'product.acf.directions', []),
  }

  // Get related products
  const relatedProducts = data.relatedProducts.edges.map(({
    node: {
      acf: nodeAcf,
      ...restNode
    },
  }) => {
    const {srcSet, sizes} = getProductCardSrcSetAndSizes(nodeAcf.thumbnail.url, nodeAcf.thumbnail.mediaDetails.width, nodeAcf.thumbnail.mediaDetails.height)

    nodeAcf.thumbnail.srcSet = srcSet
    nodeAcf.thumbnail.sizes = sizes

    return {...nodeAcf, ...restNode}
  })

  const fullUrl = `${APP_URL}${path}`

  const {
    addressNumber,
    street = {},
    ward = {},
    district = {},
    youtubeUrl = '',
  } = product

  const address = combineAddress({
    addressNumber,
    street: enhancedGet(street, 'name'),
    ward: enhancedGet(ward, 'name'),
    district: enhancedGet(district, 'name'),
    province: enhancedGet(product.province || {}, 'name'),
  })

  const youtubeVideoId = getYoutubeVideoId(youtubeUrl)

  const [token, setToken] = useState('')

  useEffect(() => {
    // eslint-disable-next-line no-undef
    setToken(localStorage.getItem('token'))
  }, [])

  const handleUpProduct = () => {
    // eslint-disable-next-line no-undef
    fetch('https://khanhpv.xyz/graphql', {
      method: 'POST',
      body: JSON.stringify({
        query: `
          mutation {
            updateProduct(
              input: {
                id: "${product.id}",
                date: "${new Date().toISOString()}",
              },
            ) {
              clientMutationId
            }
          }
        `,
      }),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      referrerPolicy: 'origin',
    })
  }

  return {
    product,
    relatedProducts,
    fullUrl,
    address,
    youtubeVideoId,
    token,
    handleUpProduct,
  }
}

const DetailsTemplate = flowRight(
  withHooks(useHooks),
  withLayout({pageName: DETAILS}),
)(Details)

export default DetailsTemplate
